'use strict';

define(['app'], function (app) {

  var productSizeGuide = function productSizeGuide() {
    var component = {};

    var _config = {
      selectors: {
        modalContent: '[data-modal-content]'
      }
    };

    var _init = function _init(element) {
      component.element = element;
      component.modalContent = component.element.querySelector(component.config.selectors.modalContent);
      component.addTabIndexesToTables(component.modalContent);
      return component;
    };

    var _addTabIndexesToTables = function _addTabIndexesToTables(modalContent) {
      var availableTables = modalContent.getElementsByTagName("tbody");
      if (availableTables !== null) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = availableTables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var table = _step.value;

            table.tabIndex = 0;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    };

    component.config = _config;
    component.init = _init;
    component.addTabIndexesToTables = _addTabIndexesToTables;

    return component;
  };

  return productSizeGuide;
});
//# sourceMappingURL=productSizeGuide.js.map
